import { datadogLogs } from '@datadog/browser-logs'

const datadogLogger = datadogLogs.createLogger('authLogger', {
  level: DD_LOGS_LEVEL || 'error',
  // eslint-disable-next-line no-undef
  handler: DD_LOGS_HANDLER || 'console',
  context: {
    domain: 'auth',
  },
})

export default datadogLogger
